module.exports = __webpack_public_path__ + "img/17.17839f5a.webp";